import React, { useState } from 'react';
import {
  Wrap,
  Form,
  CommentCount,
  List,
  ListItem,
  User,
  Content,
  Buttons
} from './styled';
import userProfileDef from 'images/sports/common/user-profile-def.png';
import Url from 'environment';
import { NamedCommunityService } from 'services/named';

const Comment = ({ data, getDetail, userData }) => {
  const { wr_comment, comment, wr_id } = data;
  const onClickDelete = async (item) => {
    if (confirm('댓글을 삭제하시겠습니까?')) {
      await NamedCommunityService.commentDelete({
        wr_id,
        board_type: 'sports_analysis',
        commentId: item.wr_id
      }).then((res) => {
        if (res.code === 200) {
          alert('댓글이 삭제되었습니다.');
          getDetail(wr_id);
        } else {
          alert(res.message);
        }
      });
    }
  };

  const onClickReport = async (item) => {
    if (confirm('신고를 접수하시겠습니까?')) {
      const params = {
        category: 'comment',
        relId: item.wr_id,
        relTable: '@sports_analysis',
        targetId: item.mb_id
      };
      await NamedCommunityService.report(params).then((res) => {
        if (res.code === 200) {
          alert('신고가 접수되었습니다.');
        } else {
          alert(res.message);
        }
      });
    }
  };

  return (
    <Wrap>
      <CommentForm wr_id={wr_id} getDetail={getDetail} />
      <CommentCount>
        댓글<em>{wr_comment}</em>
      </CommentCount>
      {!!comment && (
        <List>
          {comment.map((item, key) => {
            return (
              <CommentItem
                key={key}
                item={item}
                userData={userData}
                wr_id={wr_id}
                getDetail={getDetail}
                onClickReport={onClickReport}
                onClickDelete={onClickDelete}
              />
            );
          })}
        </List>
      )}
    </Wrap>
  );
};

const CommentItem = ({
  item,
  userData,
  wr_id,
  getDetail,
  onClickReport,
  onClickDelete,
  isReply
}) => {
  const [activeReply, setActiveReply] = useState(false);
  const [activeModify, setActiveModify] = useState(false);

  const {
    member_info,
    wr_name,
    wr_datetime,
    wr_content,
    mb_id,
    wr_comment_reply
  } = item;
  const { profile_img, today_word } = member_info;

  return (
    <ListItem isReply={isReply}>
      <User>
        <img
          src={
            member_info.profile_img
              ? `${Url.thumbCrop}/112x112${profile_img}`
              : userProfileDef
          }
          onError={(event) => {
            event.target.src = userProfileDef;
          }}
        />
        <em>{wr_name}</em>
        {today_word && <span>{today_word}</span>}
        <span>{wr_datetime}</span>
      </User>
      <Content>{wr_content}</Content>
      <Buttons>
        {wr_comment_reply.length < 2 && (
          <button
            className={activeReply ? 'active' : ''}
            onClick={() => setActiveReply(!activeReply)}
          >
            댓글
          </button>
        )}
        {userData.id !== mb_id && (
          <button onClick={() => onClickReport(item)}>신고</button>
        )}
        {userData.id === mb_id && (
          <>
            <button
              className={activeModify ? 'active' : ''}
              onClick={() => setActiveModify(!activeModify)}
            >
              수정
            </button>
            <button onClick={() => onClickDelete(item)}>삭제</button>
          </>
        )}
        {mb_id === userData.id && (
          <button className={'me active'}>내댓글</button>
        )}
      </Buttons>
      {activeReply && (
        <CommentForm
          isReply
          commentId={item.wr_id}
          wr_id={wr_id}
          getDetail={getDetail}
          setActiveReply={setActiveReply}
          setActiveModify={setActiveModify}
        />
      )}
      {activeModify && (
        <CommentForm
          isReply
          commentId={item.wr_id}
          wr_id={wr_id}
          getDetail={getDetail}
          setActiveReply={setActiveReply}
          setActiveModify={setActiveModify}
          selectedItem={item}
        />
      )}
      {!!item.comment && (
        <List>
          {item.comment.map((subItem, key) => {
            return (
              <CommentItem
                key={key}
                item={subItem}
                userData={userData}
                wr_id={wr_id}
                getDetail={getDetail}
                onClickReport={onClickReport}
                onClickDelete={onClickDelete}
                isReply
              />
            );
          })}
        </List>
      )}
    </ListItem>
  );
};

const CommentForm = ({
  wr_id,
  getDetail,
  isReply,
  commentId,
  setActiveReply = null,
  setActiveModify = null,
  selectedItem
}) => {
  const [text, setText] = useState(
    !!selectedItem ? selectedItem.wr_content : ''
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!!selectedItem) {
      // 수정
      if (isReply) {
        await NamedCommunityService.commentModify({
          wr_id,
          board_type: 'sports_analysis',
          content: text,
          commentId: commentId
        }).then((res) => {
          if (res.code === 200) {
            alert('댓글이 수정되었습니다.');
            successSubmit();
          } else {
            alert(res.message);
          }
        });
      }
      return;
    }

    if (isReply) {
      await NamedCommunityService.reCommentAdd({
        wr_id,
        board_type: 'sports_analysis',
        content: text,
        commentId: commentId
      }).then((res) => {
        if (res.code === 200) {
          alert('대댓글이 등록되었습니다.');
          successSubmit();
        } else {
          alert(res.message);
        }
      });
    } else {
      await NamedCommunityService.commentAdd({
        wr_id,
        board_type: 'sports_analysis',
        content: text
      }).then((res) => {
        if (res.code === 200) {
          alert('댓글이 등록되었습니다.');
          successSubmit();
        } else {
          alert(res.message);
        }
      });
    }
  };

  const successSubmit = () => {
    getDetail(wr_id);
    setText('');
    if (isReply) {
      setActiveReply(false);
      setActiveModify(false);
    }
  };

  const onChangeTextarea = (e) => {
    if (e.target.value.length > 500) {
      alert('댓글은 500자 까지 가능합니다.');
      return;
    }
    setText(e.target.value);
  };

  return (
    <Form onSubmit={onSubmit} isReply={isReply}>
      <textarea
        value={text}
        onChange={onChangeTextarea}
        placeholder="인터넷은 우리가 함께 만들어가는 소중한 공간입니다. 댓글 작성 시 타인에 대한 배려와 책임을 담아주세요."
      ></textarea>
      <div>
        <button type={'submit'}>댓글등록</button>
      </div>
    </Form>
  );
};

export default Comment;
